<template>
  <div class="sports-menu">
    <div class="wrapper sports-az navigation"> 
      <site-navigation :navigation-section="'HEADER_MENU_RWC'" class="about-us navigation"></site-navigation>
    </div>
  </div>

</template>
<script>
  import store from '@/store'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import Screen from '@/components/mixins/Screen'
  import config from '@/config'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'hamburger-menu',

    mixins: [
      Screen
    ],
    components: {
      SiteNavigation,
      Icon
    },
    data () {
      return {
        menuOpened: false
      }
    },
    methods: {
      toggleMyAccount () {
        if (this.dialogMyAccount) {
          store.dispatch('overlayState/deactivateMyAccountDialog')
        } else {
          store.dispatch('overlayState/activateMyAccountDialog')
        }
      },
      toggleHome () {
        this.$router.push({name: 'home'})
        store.dispatch('overlayState/deactivateBetslip')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateHamburgerMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
      }
    },
    computed: {
      externalUrls () {
        return config.externalUrls
      },
      dialogMyAccount () {
        return store.getters['overlayState/getMyAccountDialogState']
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config"

a
    color #06283b
h5
  vertical-align: middle
ul li
  padding 12px 0
  border-bottom 2px solid #e9eef5
  .pd-icon
    padding-right 10px
    font-size 30px
.expansion-panel__container--active
  .expansion-panel__header
    h3 
      font-weight bold !important
.expansion-panel
  .site-navigation
    margin-left 27px
</style>



// WEBPACK FOOTER //
// src/components/layout/parts/hamburgerMenu.vue